import React from "react";
import "./IntegrationAPIParams.css";
import { APIParameters } from "../../Utils/constants";
import { APIParamVar } from "../../Utils/variables";
const {heading} = APIParamVar;

const IntegrationAPIParams = () => {
  const APIParams = APIParameters.map((param) => (
    <div className="dflex" key={param.id}>
      <p className="Params-div-p1">{param.title}: </p>
      <p className="Params-div-p2"> {param.data}</p>
    </div>
  ));
  return (
    <div className="APIParams-div1 boxBorderRad boxBorder p10">
      <h1 className="APIParams-div1-h1">{heading}</h1>
      {APIParams}
    </div>
  );
};

export default IntegrationAPIParams;
